import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CMSContentComponent } from '../cms-content/cms-content.component';

export interface ExistingCustomerDialogData {
  customerName?: string;
}

@Component({
  selector: 'app-existing-customer-dialog',
  templateUrl: './existing-customer-dialog.component.html',
  styleUrls: ['./existing-customer-dialog.component.scss'],
})
export class ExistingCustomerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ExistingCustomerDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: ExistingCustomerDialogData
  ) {}

  openPrivacyPolicy(): void {
    this.dialog.open(CMSContentComponent, {
      width: '500px',
      data: { content: 'PrivacyPolicy' },
    });
  }

  useExisting(): void {
    this.dialogRef.close('use-existing');
  }

  addAgain(): void {
    this.dialogRef.close('add-again');
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
